import React from 'react';
import logo from './logo.svg';
import './App.css';
// import './App.scss';
import Header from './components/Header';
import { Route, Router, RouterProvider, createBrowserRouter } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import MyPage from './pages/MyPage';
import { createGlobalStyle } from 'styled-components';
import Page404 from './pages/Page404';
import Bidding from './pages/Bidding';
import Win from './pages/Win';
import Report from './pages/Report';
import Account from './pages/Account';
import Register from './pages/Register';
import AccountAdd from './pages/Account/AccountAdd';
import AccountEdit from './pages/Account/AccountEdit';
import AccountPreference from './pages/Account/AccountPreference';
import SearchResult from './pages/SearchResult';
import ResetPassword from './pages/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import VendorEdit from './pages/VendorEdit';
import ProtectedRoute from './routes/ProtectedRoute';
import SignUp from './pages/SignUp';
import BidCondition from './pages/BidCondition';
import BidProgress from './pages/BidProgress';
import Bid from './pages/Bid';
import BidCompleted from './pages/BidCompleted';
import BidStart from './pages/BidStart';
import BidConfirm from './pages/BidConfirm';
import BidUpload from './pages/BidUpload';
import ProjectDetail from './pages/ProjectDetail';
import { ApiProvider } from './api/contexts/ApiContext';
import ResetPasswordCompleted from './pages/ResetPasswordCompleted';
import VendorEditCompleted from './pages/VendorEditCompleted';
import Contact from './pages/Contact';
import ContactCompleted from './pages/ContactCompleted';
import ContactList from './pages/ContactList';
import AccountEditCompleted from './pages/Account/AccountEditCompleted';
import AccountAddCompleted from './pages/Account/AccountAddCompleted';

const GlobalStyles = createGlobalStyle`
  body {
    @import url("https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap");
    color: #3f3b3a;
    font-weight: 100;
    font-style: normal;
    font-size: 14px;
    font-family: "Noto Sans JP", sans-serif;
  }
  @media only screen and (max-width: 1199px) {
    body {
      font-size: 13px;
    }
  }
`

const router = createBrowserRouter([
  {
    path: "/",
    element: <LoginPage />,
    errorElement: <Page404 />
  },
  {
    path: "/mypage",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />
          <MyPage />
        </ProtectedRoute>
      </ApiProvider>
    ),
  },
  {
    path: "/search_result",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />
          <SearchResult />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/bid",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />
          <Bid />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/bid_start",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />
          <BidStart />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/bid_confirm",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />

          <BidConfirm />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/bid_completed",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />
          <BidCompleted />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/bidding",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />
          <Bidding />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/win",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />
          <Win />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/report",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />
          <Report />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/account",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />

          <Account />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/register",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />

          <Register />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/account_add",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />

          <AccountAdd />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/account_add_completed",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />

          <AccountAddCompleted />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/account_edit",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />

          <AccountEdit />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/account_edit_completed",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />

          <AccountEditCompleted />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/account_preference",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />

          <AccountPreference />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/reset_password",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />

          <ResetPassword />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/reset_password_completed",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />

          <ResetPasswordCompleted />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/forgot_password",
    element: (
      <ForgotPassword />
    )
  },
  {
    path: '/signup',
    element: (
      <SignUp />
    )
  },
  {
    path: "/vendor_edit",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />

          <VendorEdit />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/vendor_edit_completed",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />
          <VendorEditCompleted />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/contact",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />
          <Contact />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/contact_completed",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />
          <ContactCompleted />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  {
    path: "/contact_list",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />
          <ContactList />
        </ProtectedRoute>
      </ApiProvider>
    )
  },


  // {
  //   path: "/bid_condition",
  //   element: (
  //     <ApiProvider>
  //       <ProtectedRoute>
  //         <BidCondition />
  //       </ProtectedRoute>
  //     </ApiProvider>
  //   )
  // },
  {
    path: "/bid_progress",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />
          <BidProgress />
        </ProtectedRoute>
      </ApiProvider>
    )
  },
  // {
  //   path: "/bid_upload",
  //   element: (
  //     <ApiProvider>
  //       <ProtectedRoute>
  //         <BidUpload />
  //       </ProtectedRoute>
  //     </ApiProvider>
  //   )
  // },
  {
    path: "/project_detail",
    element: (
      <ApiProvider>
        <ProtectedRoute>
          <Header />
          <ProjectDetail />
        </ProtectedRoute>
      </ApiProvider>
    )
  }
]);

const App: React.FC = () => {
  return (
    <div className='App'>
      <GlobalStyles />
      <RouterProvider router={router} />
    </div>
  );
};

export default App;
